import React from 'react';

export default () => (
  <svg
    focusable='false'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M8.25 4.875a4.188 4.188 0 0 1 1.118 8.224 6.374 6.374 0 0 1 5.257 6.276.75.75 0 1 1-1.5 0 4.875 4.875 0 1 0-9.75 0 .75.75 0 1 1-1.5 0c0-3.14 2.27-5.749 5.257-6.277A4.186 4.186 0 0 1 8.25 4.875zm8.523 2.5a3.562 3.562 0 0 1 1.406 6.837 5.356 5.356 0 0 1 3.946 5.163.75.75 0 0 1-1.5 0 3.856 3.856 0 0 0-5.188-3.615.75.75 0 0 1-.519-1.407c.148-.055.297-.102.448-.143a3.562 3.562 0 0 1 1.407-6.835zm0 1.5a2.062 2.062 0 1 0 0 4.125 2.062 2.062 0 0 0 0-4.125zm-8.523-2.5a2.688 2.688 0 1 0 0 5.375 2.688 2.688 0 0 0 0-5.375z' />
  </svg>
);
